module.exports = __webpack_public_path__ + "static/media/facebook.8d9fd4a5.svg";